
<script context="module">

import { 
  VmCaptions 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-captions', VmCaptions);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className = '';

export let style = '';
export { className as class };

export let hidden = false;
export let isControlsActive = false;
export let isVideoView = false;
export let playbackStarted = false;
export let textTracks = [];
export let currentTextTrack = -1;
export let isTextTrackVisible = true;

export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => {
  

  __mounted = true;
});

$: if (__mounted) setProp(__ref, 'textTracks', textTracks);

const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-captions
  class={className}
  style={style}
  hidden={hidden}
  is-controls-active={isControlsActive}
  is-video-view={isVideoView}
  playback-started={playbackStarted}
  current-text-track={currentTextTrack}
  is-text-track-visible={isTextTrackVisible}
  
  bind:this={__ref}
>
  <slot></slot>
</vm-captions>
  